import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { loginCheck, getRole } from 'service/AuthService';

interface AuthState {
  isLoggedIn: boolean | null;
  userDetails: unknown;
  roles: string | null;
}

const initialState: AuthState = {
  isLoggedIn: Boolean(loginCheck()),
  userDetails: {},
  roles: getRole()
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserDetails: (state, { payload }: PayloadAction<string | null>) => ({
      ...state,
      userDetails: payload,
    }),
    setIsLoggedIn: (state, { payload }: PayloadAction<boolean | null>) => ({
      ...state,
      isLoggedIn: payload,
    }),
    setRole: (state, { payload }: PayloadAction<string | null>) => ({
      ...state,
      roles: payload,
    }),

  },
});

export const { setUserDetails, setIsLoggedIn, setRole } = authSlice.actions;

export default authSlice.reducer;
